import { useQuery } from "@tanstack/react-query";

import { IPart } from "../models/Part";
import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";
import { DefaultResponseWithData } from "../models/system";
import { IPartProConversation } from "../models/PartProMessage";

// `enabled` lets the stock page hold the call back until the user asks for messages
export default function usePartProMessagesListing(
  { part, enabled = true }: { part: IPart, enabled?: boolean },
  componentName = "usePartProMessagesListing"
) {
  const { get } = useApiHelper(apiConfig(componentName));
  const staleTime = 1000 * 60 * 10; // 10 minutes

  const conversations = useQuery({
    queryKey: ["partprolistingmessages", part.id],
    queryFn: () => get<DefaultResponseWithData<IPartProConversation[]>>(`/partpromessaging/itemmessages/${part.id}`),
    staleTime: staleTime,
    enabled: enabled,
  });

  return {
    conversations,
  };
}
